import { useRequestURL } from "#imports";
import { toBcp47Locale } from "@backmarket/utils/string/toBcp47Locale";
import { useMarketplace } from "./useMarketplace.js";
function getSubDomain(baseTarget, isPreprod) {
  if (baseTarget === "main" || baseTarget === "payment") {
    return isPreprod ? "preprod" : "www";
  }
  return isPreprod ? `${baseTarget}.preprod` : baseTarget;
}
export function useMarketBaseUrl(baseTarget, locale) {
  const target = baseTarget ?? "main";
  const { protocol, hostname } = useRequestURL();
  const isPreprod = hostname.includes("preprod.backmarket.") || // To simplify the local development, local URL will be redirected to preprod
  hostname.includes("local.backmarket.");
  const { market } = useMarketplace();
  const subDomain = getSubDomain(target, isPreprod);
  const baseUrl = `${protocol}//${subDomain}${market.domain}`;
  const baseUrlWithLocale = `${baseUrl}/${toBcp47Locale(locale ?? market.defaultLocale)}`;
  return {
    /**
     * The full URL of the targeted domain. No trailing slash.
     * @example https://www.backmarket.com
     */
    baseUrl,
    /**
     * The full URL of the targeted domain with the locale prefix. No trailing slash.
     * @example https://www.backmarket.com/en-us
     */
    baseUrlWithLocale
  };
}
